export default __webpack_public_path__ + "static/media/curriculum.7f76b9d4.svg";